// Styles partagés par DraggableShell (src/components/ui/draggable-shell.jsx) et les boîtes
// statiques de UserMessages.jsx (DialogShell, MessageBox, ConfirmationBox, WaitingBox, Toast...).
// Fichier séparé (pas de composant) : react-refresh/only-export-components interdit de mélanger
// composants et constantes dans un même fichier .jsx.
export const ICON_BTN = {
  background: 'none', border: 'none', cursor: 'pointer', padding: '4px 5px',
  color: 'hsl(var(--muted-foreground))', display: 'flex', alignItems: 'center',
  borderRadius: 4, lineHeight: 1, flexShrink: 0,
}
export const CARD_STYLE = {
  background: 'hsl(var(--background))',
  border: '1px solid hsl(var(--border))',
  borderRadius: 'var(--radius)',
  boxShadow: '0 6px 28px rgba(0,0,0,.20)',
  overflow: 'hidden',
  display: 'flex', flexDirection: 'column',
  animation: 'tbs-pop-in .15s ease',
}
export const HEADER_STYLE = {
  display: 'flex', alignItems: 'center', gap: 4,
  padding: '9px 8px 9px 16px', flexShrink: 0,
  background: 'hsl(var(--muted))',
  borderBottom: '1px solid hsl(var(--border))',
}
export const HEADER_TITLE = {
  flex: 1, fontSize: 13, fontWeight: 600,
  color: 'hsl(var(--foreground))',
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
}
export const BODY_STYLE   = { flex: 1, overflow: 'auto', padding: '16px 20px' }
export const FOOTER_STYLE = {
  padding: '10px 16px', borderTop: '1px solid hsl(var(--border))',
  display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0,
}
